import { selectExclusiveContent } from '@debbie/cortex/dist/exclusiveContent/selectors.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useMe } from '@debbie/cortex/dist/me/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import THEME from '../theme.js';
import Badge from './Badge.js';
export const ExclusiveContent = (props) => {
    const meLoadable = useMe();
    const me = h.hasData(meLoadable) ? meLoadable.data : null;
    const exclusiveContent = useSelector(selectExclusiveContent);
    return (React.createElement(React.Fragment, null, me && exclusiveContent && exclusiveContent.includes(me.id)
        ? props.children
        : props.fallback != null
            ? React.createElement(props.fallback)
            : null));
};
export default ExclusiveContent;
export const ExclusiveContentBadge = () => {
    const exclusiveContent = useSelector(selectExclusiveContent);
    const meLoadable = useMe();
    const me = h.hasData(meLoadable) ? meLoadable.data : null;
    return (React.createElement(Badge, { theme: me && exclusiveContent?.includes(me.id)
            ? THEME.COLOR_ACCENT
            : THEME.COLOR_GREY, style: { fontWeight: 900, verticalAlign: 'middle' } }, "Exclusive Content"));
};
//# sourceMappingURL=ExclusiveContent.js.map